// increase upload timeout duration as multiple
// actions are performed on uploaded resume
export const UPLOAD_TIMEOUT_DURATION = 60000 

const Durations = {
  uploadTimeout: UPLOAD_TIMEOUT_DURATION,
}

export default Durations
